import { BaseService } from '../../infra/base.service'
import type { Invoice } from './invoice'
import type { InvoicesRepository } from './invoices.repository'

export class InvoicesService extends BaseService<Invoice> {
    constructor(private rep: InvoicesRepository) {
        super(rep)
    }

    async upsert(dto: Partial<Invoice>) {
        return await this.rep.upsert(dto)
    }

    async setTaxInvoiceId(invoiceId: string, taxInvoiceId: string) {
        return await this.rep.setTaxInvoiceId(invoiceId, taxInvoiceId)
    }

    async getBuyers(from: Date, to: Date) {
        return await this.rep.getBuyers(from, to)
    }

    async getComissions(params?: { page?: number; from?: Date; to?: Date; query?: string } | any) {
        return await this.rep.getComissions(params)
    }

    async comissionsChangeStatus(servicesOnInvoicesId: string, active: boolean) {
        return await this.rep.comissionsChangeStatus(servicesOnInvoicesId, active)
    }

    async comissionsRecalculate(params: { from: Date; to: Date }) {
        return await this.rep.comissionsRecalculate(params)
    }

    async getEvolution() {
        return await this.rep.getEvolution()
    }

    async getTotalByMonth(from: Date, to: Date) {
        return await this.rep.getTotalByMonth(from, to)
    }

    async getTotalByDay(from: Date, to: Date) {
        return await this.rep.getTotalByDay(from, to)
    }

    async getCreditAndDebitsFromPerson(personId: string) {
        let noPaid = 0
        const invoices: Invoice[] = await this.getAll({ personId })
        for (const invoice of invoices) {
            if (invoice.status !== 'subsidized') {
                noPaid += invoice.total - invoice.totalPaid
            }
        }
        return noPaid
    }
}
